export default [
    {
        id: 'hires',
        text: 'hires'
    },
    {
        id: 'large',
        text: 'large'
    },
    {
        id: 'medium',
        text: 'medium'
    },
    {
        id: 'small',
        text: 'small'
    },
    {
        id: 'thumbnail',
        text: 'thumbnail'
    }
];